export const DEFAULT_GIFT_THUMB_URL =
  "http://res.cloudinary.com/dlb6roslw/image/upload/v1597264386/nn9llkgdpk0xjmykbigz.jpg";
